
import { cloneObject, makeEdge, makeNodeDot } from './utils';
//import { makeConceptNode } from './utilsConceptModel';
import JSZip from "jszip";

// Add a new Narrative
export function addNarrative(dsd, Data, onAdd, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadNarrative(Data);

    dsd.httpConfig.post(`/narratives`, payload, headers)
        .then(response => {
            if (onAdd) {
                onAdd(response.data._id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Edit an existing Narrative
export function editNarrative(dsd, id, Data, onUpdate, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadNarrative(Data);

    dsd.httpConfig.put(`/narratives/${id}`, payload, headers)
        .then(response => {
            if (onUpdate) {
                onUpdate();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}

// Create payload for Narrative
export function payloadNarrative(data) {
    let payload = {};
    payload.name = data.name;
    payload.description = data.description;
    payload.proposals = data.proposals;
    payload.status = data.status;

    payload.Concepts = [];

    if (data.Keys) {
        payload.Keys = data.Keys;
    }
    if (data.Concepts) {
        payload.Concepts = data.Concepts;
    }
    if (data.Links) {
        payload.Links = data.Links;
    }

    return payload;
}

// Process Narrative data
export function dataNarrative(data) {
    let obj = data;
    return obj;
}


export const getNarrative = (dsd, id=null, onLoad=null, onFail=null, representation="dsd", format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/narratives/${id}?`

        if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};



// List Narratives with optional filters
export function listNarratives(dsd, Filters = {}, onLoad, onError) {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/narratives";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope) {
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status) {
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search) {
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arr.push(dataNarrative(response.data[pos]));
            }

            if (onLoad) {
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.log(e);
        });

    return;
}



export const getNarrativeVersion = (dsd, id=null, idVersion = null, onLoad=null, onFail=null, representation='dsd', format=null, options={}) => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/narratives/${id}/version/${idVersion}?`

    if (representation){
        URL += `&representation=${representation}`;
    }

    if (format){
        URL += `&format=${format}`;
    }

    if (options) {
        for (const [key, value] of Object.entries(options)) {
            if (value === true) URL += `&${key}=true`;
            else if (value !== false && value != null) URL += `&${key}=${encodeURIComponent(value)}`;
        }
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
            
    );

    return;

};


export const zipNarrative = async function(dsd, idNarrative, idVersion){

    const zip = new JSZip();

    const assets = await assetsNarrativeVersion(dsd, idNarrative, idVersion);

    const Narrative = assets["dsd.json"];

    let nameFolder = `narrative_${idNarrative}`;
    if (idVersion){
        nameFolder += `_version_${idVersion}`;
    }

    for (const idAsset in assets){
        let assetValue = assets[idAsset];

        // Serialize JSON-like objects before zipping.
        if (
            typeof assetValue === 'object' &&
            assetValue !== null &&
            !(assetValue instanceof Blob) &&
            !(assetValue instanceof ArrayBuffer) &&
            !(assetValue instanceof Uint8Array)
        ) {
            assetValue = JSON.stringify(assetValue, null, 4);
        }

        zip.file(`${nameFolder}/${idAsset}`, assetValue);

// repeat for /site and /siteGDS


        if (idAsset.startsWith("site/") || idAsset.startsWith("siteGDS/")) {
            continue;
        }

        switch (idAsset) {
            case "page.md":
            case "index.html":
            case "indexGDS.html":
                break; // Skip these files for /site and /siteGDS
            default:{
                zip.file(`${nameFolder}/site/${idAsset}`, assetValue);
                zip.file(`${nameFolder}/siteGDS/${idAsset}`, assetValue);
            }
        }
    }

    const zipData = await zip.generateAsync({
        type: "blob",
        streamFiles: true,
    });

    return zipData;

};



export const assetsNarrativeVersion = async function(dsd, idNarrative, idVersion){

    
    let Promises = [];

    let doc = null;
    let page = null;
    let index = null;
    let indexGDS = null;

    let site = null;
    let siteGDS = null;

    let svg = null;
    let dot = null;

    const assets = {};
    let Narrative = null



    const onDoneDoc = function(reply){
        doc = reply;
        return;
    };


    const onDonePage = function(reply){
        page = reply;
        return;
    };


    const onDoneIndex = function(reply){
        index = reply;
        return;
    };

    const onDoneIndexGDS = function(reply){
        indexGDS = reply;
        return;
    };


    const onDoneSite = function(reply){
        site = reply;
        return;
    };

    const onDoneSiteGDS = function(reply){
        siteGDS = reply;
        return;
    };


    const onDoneSvg = function(reply){
        svg = reply;
        return;
    };


    const onDoneDot = function(reply){
        dot = reply;
        return;
    };

    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneDoc));
    
    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDonePage, null,'page'));
    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneIndex, null,'page', 'html'));

    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneIndexGDS, null,'page', 'html',{style:'UK Government Design System'}));

    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneSite, null,'site', 'json'));
    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneSiteGDS, null,'site', 'json',{style:'UK Government Design System'}));

    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneSvg, null,'image', 'svg'));
    Promises.push(getNarrativeVersion(dsd,idNarrative,idVersion, onDoneDot, null,'dot'));

    return(
        Promise.all(Promises)
        .then(async response => {

            if (doc){
                assets["dsd.json"] = doc;
                Narrative = cloneObject(doc);
            }

            if (page){
                assets["page.md"] = page;
            }
            if (index){
                assets["index.html"] = index;
            }
            
            if (indexGDS){
                assets["indexGDS.html"] = indexGDS;
            }

            if (dot){
                assets["dot.txt"] = dot;
            }

            if (svg){
                assets["image.svg"] = svg;
            }
        
            if (site && site.files){
                for (const file of site.files){
                    if (file.content != null){
                        assets[`site/${file.path}`] = file.content;
                    }
                }
            }

            if (siteGDS && siteGDS.files){
                for (const file of siteGDS.files){
                    if (file.content != null){
                        assets[`siteGDS/${file.path}`] = file.content;
                    }
                }
            }

            return assets;    

        })
    )

};